import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {MenuGruppe, MenuState} from '../../models/menuState';
import {NgForm} from '@angular/forms';
import {UiInputControl} from '../../models/uiArtefakt';
import {UIDarstellungsart} from '../../models/uiDarstellungsart';
import {EventService} from '../../services/event.service';
import {filter, map, withLatestFrom, tap} from 'rxjs/operators';
import {BehaviorSubject, combineLatest, Observable, Subject} from 'rxjs';
import {UILayout} from '../../models/uiLayout';
import {ShellConfigService} from '../../services/shell-config.service';

@Component({
    selector: 'lv-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit, AfterViewInit {

  @ViewChild(NgForm, {static: true})
  private _ngForm;

  public isDisabled: boolean = false;
  public menuGruppenIndexObs$: Observable<MenuGruppe>;
  public currentMenuGruppenIndex: number = 0;
  public lastClosedMenuGruppenIndex: number;
  public menuState$: Observable<MenuState>;
  public showMenuGruppeInErrorState: string[];

  public uiLayoutEnum = UILayout;
  public uiLayout: UILayout;
  public showMenu: boolean;

  private _uiArtefakt: UiInputControl;
  private _menuGruppenSubject$: BehaviorSubject<number> = new BehaviorSubject(0);

  public constructor(private _eventService: EventService,
                     private _shellConfigService: ShellConfigService,
                     private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): UiInputControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: UiInputControl) {
    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }


  public ngOnInit(): void {
    this.uiLayout = this._shellConfigService.getParameter().uiLayout;
    this.showMenu = this._shellConfigService.shellParameter.showMenu;
    this.menuState$ = this._eventService.menuState$;
    this.menuGruppenIndexObs$ = combineLatest([this._eventService.menuItemSelected$, this._menuGruppenSubject$]).pipe(
        withLatestFrom(this._eventService.menuState$, this._eventService.highestClickedMenuItem$),
        tap(([[menuSeiteSelected, menuGruppenIndex], menuState, highestClickedMenuItem]) => {
          this.showMenuGruppeInErrorState = [];
          menuState.MenuGruppen.forEach((menugruppe, gruppenIndex) => {
            if(menugruppe.MenuSeiten.filter(seite => menuSeiteSelected === seite.Identifikator).length > 0){
              this.currentMenuGruppenIndex = gruppenIndex;
            }
            if (menugruppe.MenuSeiten.filter(seite => !seite.valid && seite.index <= highestClickedMenuItem).length > 0) {
              this.showMenuGruppeInErrorState.push(menugruppe.Identifikator);
            }
          });
        }),
        filter(([[menuSeiteSelected, menuGruppenIndex], _, __]) => !!menuSeiteSelected),
        map(([[menuSeiteSelected, menuGruppenIndex], menuState, highestClickedMenuItem]) =>
          menuState.MenuGruppen.filter(menugruppe =>
              !!menugruppe.MenuSeiten.filter(seite =>
                  menuSeiteSelected === seite.Identifikator).length)[0]
        ),
    );
  }

  gruppeClicked(gruppenClicked: number) {
    this.currentMenuGruppenIndex = gruppenClicked;
    this._menuGruppenSubject$.next(gruppenClicked);
  }

  closedMenuGruppe(i: number) {
    this.lastClosedMenuGruppenIndex = i;
  }
}
